import {
  FormControl,
  FormControlLabel,
  FormHelperText,
  InputLabel,
  Slider as MuiSlider,
  SliderProps,
} from '@mui/material';
import { FC } from 'react';
import { formControlLabelStyle } from '../switch/Switch.style';

export type CustomSliderProps = SliderProps & {
  step?: number;
  label?: string;
  helperText?: string;
  error?: boolean;
  showMarks?: boolean;
};

export const Slider: FC<CustomSliderProps> = ({
  min = 0,
  max = 5,
  step = 1,
  showMarks = true,
  helperText,
  error,
  label,
  size,
  sx,
  ...props
}: CustomSliderProps) => {
  const marks = Array.from({ length: (max - min) / step + 1 }, (_, index) => ({
    value: index * step + min,
    label: index * step + min,
  }));
  return (
    <FormControl
      fullWidth
      size={size}
      sx={{
        ...sx,
        width: 'calc(100% - 16px)',
      }}
    >
      <FormControlLabel
        sx={{
          ...formControlLabelStyle,
        }}
        label={label ? <InputLabel>{label}</InputLabel> : null}
        labelPlacement="top"
        control={<MuiSlider size={size} min={min} max={max} step={step} marks={showMarks && marks} {...props} />}
      />
      {helperText && <FormHelperText error={error}>{helperText}</FormHelperText>}
    </FormControl>
  );
};
